import React from "react";

export function Card({ children, bgColor = 'bg-white', className = '' }) {
  return (
    <div className={`rounded-2xl p-6 sm:p-7 shadow-card border border-slate-100/80 transition-all duration-300 ease-out hover:shadow-card-hover ${bgColor} ${className}`}>
      {children}
    </div>
  );
}